import React from 'react';
import PropTypes from 'prop-types';

export function AssetImg({ src, attrs }) {
  let adjustedSrc;
  switch (window.location.host) {
    case 'www.mockingjay.test:3000':
      // matches in the nix development environment
      adjustedSrc = `http://webpack.mockingjay.kobubob.test:8888${src}`;
      break;
    default:
      adjustedSrc = src;
  }
  return <img src={adjustedSrc} {...attrs} />;
}

AssetImg.propTypes = {
  src: PropTypes.string.isRequired,
  attrs: PropTypes.object,
};

AssetImg.defaultProps = {
  attrs: {},
};
